import React from 'react';
import UspItem from './UspItem';
import {
	ONBOARDING_GENERIC_USP_1,
	ONBOARDING_GENERIC_USP_2,
	ONBOARDING_GENERIC_USP_3,
	ONBOARDING_TVGEMIST_USP_1,
	ONBOARDING_TVGEMIST_USP_2,
	ONBOARDING_TVGEMIST_USP_3,
} from '../../../constants/Copy';

const uspTitleListAll = [
	ONBOARDING_GENERIC_USP_1,
	ONBOARDING_GENERIC_USP_2,
	ONBOARDING_GENERIC_USP_3,
];
const uspTitleListTvGemist = [
	ONBOARDING_TVGEMIST_USP_1,
	ONBOARDING_TVGEMIST_USP_2,
	ONBOARDING_TVGEMIST_USP_3,
];
const uspTitleListTrustedParty = [ONBOARDING_GENERIC_USP_2, ONBOARDING_GENERIC_USP_3];

const renderUspItem = (title, idx) => <UspItem title={title} key={`onboarding_USP_${idx}`} />;

const UspList = ({ isTrustedParty, isTvGemist }) => {
	if (isTrustedParty) return <div>{uspTitleListTrustedParty.map(renderUspItem)}</div>;
	if (isTvGemist) return <div>{uspTitleListTvGemist.map(renderUspItem)}</div>;

	return <div>{uspTitleListAll.map(renderUspItem)}</div>;
};

export default UspList;
